import React from 'react';
import SectionHeader from '@/components/site/SectionHeader';
import GoldText from '@/components/site/GoldText';

const stages = [
  {
    n: '01',
    stage: 'Discover',
    title: 'Free discovery call',
    body: 'Discuss the workflow, the current process, and the result worth testing.',
    outcomeLabel: 'You leave with',
    outcome: 'A recommended next step, which may or may not be an AI pilot.',
    figure: 'Discover',
    figureNote: 'Free · No commitment',
  },
  {
    n: '02',
    stage: 'Pilot',
    title: 'AI assistant pilot',
    body: 'Build and evaluate one assistant within a defined scope.',
    outcomeLabel: 'You receive',
    outcome: 'A working pilot, testing, operating guidance, and a results review.',
    figure: 'Pilot',
    figureNote: 'One workflow · Defined scope',
  },
  {
    n: '03',
    stage: 'Improve & Expand',
    title: 'Optional ongoing consulting',
    body: 'Review what is happening, refine the workflow, and prioritize future work.',
    outcomeLabel: 'You gain',
    outcome: 'A continuing partner for practical AI decisions.',
    figure: 'Expand',
    figureNote: 'Optional · Agreed separately',
  },
];

const OfferLadder = () => (
  <section aria-labelledby="ladder-title" className="border-t border-rule">
    <div className="section-container">
      <SectionHeader
        id="ladder-title"
        eyebrow="03 / The offer"
        title={
          <>
            Start free. Test one workflow. <GoldText>Build from the results.</GoldText>
          </>
        }
      >
        <p>You do not need to commit to a broad implementation before understanding where an assistant could help.</p>
      </SectionHeader>

      <ol className="reveal mt-14 grid border border-rule md:grid-cols-3">
        {stages.map((s) => (
          <li
            key={s.n}
            className="flex flex-col border-b border-rule p-7 last:border-b-0 sm:p-8 md:border-b-0 md:border-r md:last:border-r-0"
          >
            <p className="meta-label mb-6">{s.n}</p>
            <p className="font-serif text-[4rem] leading-none">
              <span className="gold-shine">{s.figure}</span>
            </p>
            <p className="meta-label mt-3">{s.figureNote}</p>
            <h3 className="mt-8 text-[1.75rem] leading-tight">{s.title}</h3>
            <p className="mt-3 text-mist">{s.body}</p>
            <div className="mt-auto pt-8">
              <div className="border-t border-rule pt-5">
                <p className="meta-label mb-1.5">{s.outcomeLabel}</p>
                <p className="text-softwhite">{s.outcome}</p>
              </div>
            </div>
          </li>
        ))}
      </ol>

      <p className="reveal mt-8 text-mist">
        Each stage has a clear purpose. Moving to the next stage is a separate decision.
      </p>
    </div>
  </section>
);

export default OfferLadder;
